import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../utils/api";
import { stripJwtFromStorage } from "../utils/authSession";

const SESSION_TIMEOUT_EVENT = "session-timeout-event";

const clearSessionLocal = () => {
  stripJwtFromStorage();
  localStorage.removeItem("userId");
  localStorage.removeItem("orgId");
  localStorage.removeItem("accessModules");
  localStorage.removeItem("role");
  localStorage.removeItem("portalTenantView");
  localStorage.removeItem("portalTenantOrgId");
  localStorage.removeItem("plan");
  localStorage.removeItem("plan_status");
};

const SessionTimeoutModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("Your session has expired. Please log in again.");
  const navigate = useNavigate();

  const endSession = async () => {
    const userId = localStorage.getItem("userId");
    try {
      if (userId) {
        await api("/logout", {
          method: "POST",
          body: JSON.stringify({ userId }),
        });
      }
    } catch {
      /* ignore */
    }
    clearSessionLocal();
    setIsOpen(false);
    navigate("/nyafaz-brand", { replace: true });
  };

  useEffect(() => {
    const handleSessionTimeout = (event) => {
      const nextMessage = String(event?.detail?.message || "Your session has expired. Please log in again.");
      setMessage(nextMessage);
      setIsOpen(true);
    };

    window.addEventListener(SESSION_TIMEOUT_EVENT, handleSessionTimeout);
    return () => window.removeEventListener(SESSION_TIMEOUT_EVENT, handleSessionTimeout);
  }, []);

  useEffect(() => {
    if (!isOpen) return;
    const timer = window.setTimeout(() => {
      endSession();
    }, 2200);
    return () => window.clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, navigate]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[99998] flex items-center justify-center bg-black/55 p-4 backdrop-blur-sm">
      <div className="w-full max-w-md rounded-2xl border border-white/40 bg-transparent p-6 shadow-[0_18px_50px_rgba(0,0,0,0.28)]">
        <h3 className="text-xl font-semibold text-white">Session Timed Out</h3>
        <p className="mt-3 text-sm font-medium text-white">{message}</p>
        <div className="mt-5 flex justify-end">
          <button
            type="button"
            onClick={endSession}
            className="rounded-xl border border-white/70 bg-white/10 px-4 py-2 text-sm font-semibold text-white transition hover:bg-white/20"
          >
            Go to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionTimeoutModal;
